import { graphql, useStaticQuery } from 'gatsby'

export const usePlatformsScores = () => {
  const {
    scores: { nodes: scores },
  } = useStaticQuery<Queries.PlatformsScoresQuery>(graphql`
    query PlatformsScores {
      scores: allContentfulPlatformScore {
        nodes {
          ...ContentfulPlatformScore
        }
      }
    }
  `)
  return scores
}
